import { batch } from "react-redux";

import { hidePopUp, showPopUp } from "@/actions/modalActions";
import {
  setAdvSetupSelected,
  setDisableSaveSetupButton,
  setEditAdvSetup,
  setLastAdvSetupIdView,
  setSaveAdvSetup,
  setTitleMenuProperties,
  showAlert,
  updateCurrentAdvSetupParam,
} from "@/actions/setupActions";
import { createAdvSetupApi, editAdvSetupApi } from "@/api/advSetupApi";
import { AUTO_RECOVERY, HIGH_VOLUME_BUFFER } from "@/constants/fieldNames";
import { HIGH_VOLUME_BUFFER_INFO } from "@/constants/messages";
import * as APPDATA from "@/constants/pcConstAppData";
import { formatMessage } from "@/libs/intlHelper";
import { isContainSymbol, isExist } from "@/libs/nameHelper";
import {
  goToAdvSetupExplorerScreen,
  goToAutoSetupScreen,
} from "@/libs/navigationHelper";

export const createAdvSetup = (advSetup, id) => async (dispatch, getState) => {
  try {
    const { setupStore } = { ...getState() };
    const { editAdvSetup } = setupStore;
    console.log({ data: { ...advSetup, [APPDATA.KEY.Id]: -1 } });
    const response = await createAdvSetupApi({
      ...advSetup,
      [APPDATA.KEY.Id]: -1,
    });

    const advSetupCreated = {
      [APPDATA.KEY.Id]: response.data.Id,
      [APPDATA.KEY.Name]: response.data.Name,
      [APPDATA.KEY.ConfigAdvSetup]: response.data.ConfigAdvSetup,
    };

    if (editAdvSetup) goToAdvSetupExplorerScreen();
    else goToAutoSetupScreen();

    batch(() => {
      dispatch(setAdvSetupSelected(advSetupCreated));
      if (response.data.Id === id) {
        dispatch(updateCurrentAdvSetupParam(advSetupCreated));
      }
      dispatch(setLastAdvSetupIdView(response.data.Id));
      if (editAdvSetup) dispatch(setEditAdvSetup(false));
      dispatch(setSaveAdvSetup(false));
    });
  } catch (error) {
    console.error("Error editing advSetup:", error);
  }
};

export const editAdvSetup = (advSetup) => async (dispatch) => {
  try {
    // const {setupStore} = {...getState()};
    // const {editAdvSetup} = setupStore;
    const response = await editAdvSetupApi(advSetup);

    const advSetupCreated = {
      [APPDATA.KEY.Id]: response.data.Id,
      [APPDATA.KEY.Name]: response.data.Name,
      [APPDATA.KEY.ConfigAdvSetup]: response.data.ConfigAdvSetup,
    };

    goToAdvSetupExplorerScreen();
    batch(() => {
      dispatch(setAdvSetupSelected(advSetupCreated));
      dispatch(setSaveAdvSetup(false));
      dispatch(setEditAdvSetup(false));
    });
  } catch (error) {
    console.error("Error editing advSetup:", error);
  }
};

export const validateNameAdvSetup =
  (value, isSaved = false) =>
  (dispatch, getState) => {
    let isValid = false;
    const { setupStore } = { ...getState() };
    const { advSetupList, advSetupSelected } = setupStore;

    if (isContainSymbol(value)) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText:
            APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CONTAIN_SYMBOLS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        })
      );
    } else if (!value) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText:
            APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CANNOT_BE_EMPTY,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        })
      );
    } else if (isExist(value, advSetupList)) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText:
            APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_ALREADY_EXIST,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        })
      );
    } else {
      isValid = true;

      batch(() => {
        dispatch(
          setAdvSetupSelected({
            ...advSetupSelected,
            [APPDATA.KEY.Name]: value,
          })
        );
        dispatch(setDisableSaveSetupButton(true));
        if (isSaved) {
          dispatch(
            setTitleMenuProperties(`${APPDATA.ADVANCED_SETUP_NEW} - ${value}`)
          );
          dispatch(setSaveAdvSetup(true));
        }
      });
    }

    return {
      latestName: advSetupSelected[APPDATA.KEY.Name],
      isValid,
    };
  };

export const handleIconInfo = (id) => (dispatch) => {
  dispatch(showAlert({ alertShow: false }));
  switch (id) {
    case AUTO_RECOVERY:
      dispatch(
        showPopUp({
          popUpTitle: APPDATA.MESSAGES.AUTO_RECOVERY_INFO.TITLE,
          popUpText: APPDATA.MESSAGES.AUTO_RECOVERY_INFO.TEXT,
          popUpButton: [
            {
              id: APPDATA.GOT_IT,
              isPrimaryButton: true,
              label: APPDATA.GOT_IT,
              onClick: () => dispatch(hidePopUp()),
            },
          ],
          popUpHideCloseButton: true,
        })
      );
      break;
    case HIGH_VOLUME_BUFFER:
      dispatch(
        showPopUp({
          popUpTitle: formatMessage({ id: "modal.highVolumeBuffer.title" }),
          popUpText: HIGH_VOLUME_BUFFER_INFO.TEXT,
          popUpButton: [
            {
              id: APPDATA.GOT_IT,
              isPrimaryButton: true,
              label: APPDATA.GOT_IT,
              onClick: () => dispatch(hidePopUp()),
            },
          ],
          popUpHideCloseButton: true,
        })
      );
      break;
    default:
      console.log(`No info handler for label: ${id}`);
  }
};
